import type { DeepPartial } from '@luna/utils-ts';

import type { SepaDirectDebit } from './SepaDirectDebit';

export const HR: DeepPartial<SepaDirectDebit> = {};
